import { all, takeLatest } from 'redux-saga/effects';
import { types as modalsAnchorActions } from '@/bit/reducers/reducers.modals-reducer';
import {
  initAnchorModalListener,
  addModal,
} from '@/bit/sagas/sagas.modals-saga';
import { types as headerActions } from '@/bit/reducers/reducers.header-reducer';
import { types as mainActions } from '@/bit/reducers/reducers.main-reducer';
import { types as accountTypes } from '@/reducers/account-reducer';
import { checkCPAndSetZones } from '@/bit/sagas/sagas.main-saga';
import {
  getSearcherInfo,
  getRelatedPages,
} from '@/bit/sagas/sagas.header-saga';
import {
  setInfoAccount,
  sendOtpAccount,
  validateOtpAccount,
  progressObdAccount,
  progressOtpAccount,
} from './accountForm';

function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(accountTypes.SET_INFO, setInfoAccount),
    takeLatest(accountTypes.SEND_OTP, sendOtpAccount),
    takeLatest(accountTypes.VALIDATE_OTP, validateOtpAccount),
    takeLatest(accountTypes.PROGRESS_OBD, progressObdAccount),
    takeLatest(accountTypes.PROGRESS_OTP, progressOtpAccount),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    /* opcionales */
    takeLatest(headerActions.GET_SEARCHER_INFO, getSearcherInfo),
    takeLatest(headerActions.GET_RELATED_PAGES, getRelatedPages),
    /* ### */
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
  ]);
}

export default rootSaga;
